import { Edit } from "react-admin";
import * as React from "react";
import { CarRentCreateForm } from "./CarRentCreate";

export const CarRentEdit = () => (
  <Edit>
    <CarRentCreateForm />
  </Edit>
);
